export default "__VITE_ASSET__Oft9L1vj__"